import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, ArrowRight, Lock, CreditCard, Shield, Clock } from 'lucide-react';
export function PurchaseSection() {
  const features = ['Acceso inmediato a todo el sistema', 'Manuales, actividades y correcciones', 'Bonos exclusivos incluidos', 'Actualizaciones futuras gratis', 'Material 100% editable y personalizable', 'Soporte prioritario por email'];
  return <section id="purchase" className="py-24 bg-gray-900 text-white relative overflow-hidden" data-id="element-120">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-121">
        <div className="absolute top-1/4 left-1/4 w-[500px] h-[500px] bg-blue-600 rounded-full filter blur-[128px] opacity-20 animate-pulse" data-id="element-122"></div>
        <div className="absolute bottom-1/4 right-1/4 w-[500px] h-[500px] bg-purple-600 rounded-full filter blur-[128px] opacity-20 animate-pulse" style={{
        animationDelay: '2s'
      }} data-id="element-123"></div>
      </div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-124">
        <div className="text-center mb-16" data-id="element-125">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-126">
            Recuperá tu tiempo y tu tranquilidad hoy mismo
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-127">
            Todo lo que necesitás para dar clases increíbles sin quemarte, en un
            solo lugar.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white text-gray-900 rounded-3xl shadow-2xl overflow-hidden max-w-lg mx-auto border-4 border-blue-500/30" data-id="element-128">
          <div className="bg-gradient-to-r from-blue-600 to-blue-700 p-4 text-center text-white font-bold tracking-wider text-sm uppercase shadow-md" data-id="element-129">
            Oferta Limitada - Descarga Inmediata
          </div>

          <div className="p-8 md:p-12" data-id="element-130">
            <div className="text-center mb-10" data-id="element-131">
              <h3 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-132">
                PACK INGLÉS LISTO™
              </h3>
              <p className="text-gray-500 mb-8 font-medium" data-id="element-133">
                Edición Completa + Bonos
              </p>

              <div className="flex flex-col items-center gap-2 mb-6" data-id="element-134">
                <div className="flex items-center gap-3" data-id="element-135">
                  <span className="text-gray-400 line-through text-2xl font-medium" data-id="element-136">
                    $49 USD
                  </span>
                  <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm font-bold border border-green-200" data-id="element-137">
                    AHORRÁS 71%
                  </span>
                </div>
                <div data-id="element-138">
                  <div className="text-6xl font-extrabold text-gray-900 tracking-tight" data-id="element-139">
                    $14{' '}
                    <span className="text-xl font-bold text-gray-500 align-top mt-2 inline-block" data-id="element-140">
                      USD
                    </span>
                  </div>
                  <p className="text-xs text-gray-400 mt-2" data-id="element-141">
                    El pago se procesará en la moneda de tu país
                  </p>
                </div>
              </div>
              <p className="text-sm text-gray-500 font-medium bg-gray-100 inline-block px-4 py-1 rounded-full" data-id="element-142">
                Pago único. Acceso de por vida.
              </p>
            </div>

            <div className="bg-gray-50 rounded-xl p-6 mb-10 border border-gray-100" data-id="element-143">
              <ul className="space-y-4" data-id="element-144">
                {features.map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-145">
                    <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-146" />
                    <span className="text-gray-700 font-medium text-left" data-id="element-147">
                      {feature}
                    </span>
                  </li>)}
              </ul>
            </div>

            <a href="https://checkout1.edulabs.online/cart/42427202633826:1" target="_blank" rel="noopener noreferrer" className="block w-full group mb-6" data-id="element-148">
              <motion.button whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="w-full bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 text-white font-bold py-4 px-6 rounded-xl shadow-lg hover:shadow-orange-500/40 transition-all duration-300 flex flex-col items-center justify-center gap-1.5 relative overflow-hidden" data-id="element-149">
                <div className="flex items-center gap-2.5 text-lg" data-id="element-150">
                  <Clock className="w-5 h-5" data-id="element-151" />
                  <span data-id="element-152">APROVECHAR OFERTA AHORA</span>
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-153" />
                </div>
                <span className="text-xs font-medium opacity-90" data-id="element-154">
                  ⚡ Solo por tiempo limitado
                </span>
              </motion.button>
            </a>

            {/* Trust badges */}
            <div className="space-y-4" data-id="element-155">
              <div className="flex items-center justify-center gap-6 text-gray-400 text-xs flex-wrap" data-id="element-156">
                <div className="flex items-center gap-2" data-id="element-157">
                  <Lock className="w-4 h-4" data-id="element-158" />
                  <span className="font-medium" data-id="element-159">Pago 100% Seguro</span>
                </div>
                <div className="w-1 h-1 bg-gray-300 rounded-full" data-id="element-160"></div>
                <div className="flex items-center gap-2" data-id="element-161">
                  <Shield className="w-4 h-4" data-id="element-162" />
                  <span className="font-medium" data-id="element-163">Garantía 7 días</span>
                </div>
              </div>

              {/* Payment methods */}
              <div className="flex items-center justify-center gap-4 pt-2" data-id="element-164"></div>
            </div>
          </div>

          <div className="bg-gray-50 p-6 text-center border-t border-gray-200" data-id="element-165">
            <p className="text-gray-900 font-bold mb-3 text-sm uppercase tracking-wide" data-id="element-166">
              Pack Inglés Listo™ te devuelve:
            </p>
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-gray-600 font-medium" data-id="element-167">
              <span className="flex items-center gap-1" data-id="element-168">
                <CheckCircle className="w-3 h-3 text-blue-500" data-id="element-169" /> Tiempo
              </span>
              <span className="flex items-center gap-1" data-id="element-170">
                <CheckCircle className="w-3 h-3 text-blue-500" data-id="element-171" /> Control
              </span>
              <span className="flex items-center gap-1" data-id="element-172">
                <CheckCircle className="w-3 h-3 text-blue-500" data-id="element-173" /> Tranquilidad
              </span>
              <span className="flex items-center gap-1" data-id="element-174">
                <CheckCircle className="w-3 h-3 text-blue-500" data-id="element-175" /> Energía
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}